<script lang="ts">
</script>

<!-- container with semi-transparent background -->
<div class="rounded-lg bg-gray-50 p-8 dark:bg-gray-800">
	<div class="prose prose-lg dark:prose-invert max-w-none">
		<slot />
	</div>
</div>
